if (!Array.prototype.fill) {
    Object.defineProperty(Array.prototype, 'fill', {
        value: function (value) {

            if (this === null) {
                throw new TypeError('this is null or not defined');
            }

            var O = Object(this);
            // tslint:disable-next-line:no-bitwise
            var len = O.length >>> 0;
            var start = arguments[1];
            // tslint:disable-next-line:no-bitwise
            var relativeStart = start >> 0;

            var k = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);

            var end = arguments[2];
            // tslint:disable-next-line:no-bitwise
            var relativeEnd = end === undefined ? len : end >> 0;

            var final = relativeEnd < 0 ?
                Math.max(len + relativeEnd, 0) :
                Math.min(relativeEnd, len);

            while (k < final) {
                O[k] = value;
                k++;
            }

            return O;
        }
    });
}


$.widget("fac.ccGrid", {

    //$myContainer: null,
    me: this,
    panelJSON: null,
    firstRun: true,
    panelHolderNode: null,
    thisPanel: 0,
    activeStickys: [],
    removeStickys: [],
    subNavBottom: false,
    animation_delay: 500,
    sticky: '.grid__item--sticky',
    initialLoad: true,
    handleBarsTemplates: {
        image: null,
        text: null,
        link: null,
        subnav: null,
        team: null,
        project: null,
        gridCell: null,
        mobileSpace: null
    },

    // Variables
    panelAPIUrl: '/umbraco/surface/panelManager/GetPanelsJSON/',		// API location



    _writeOutCellRows: function (rows) {

        this.handleBarsTemplates.gridCell = Handlebars.compile(document.getElementById("SingleGridCell").innerHTML);
        var totalCells = rows * 9;
        //console.log('_writeOutCellRows : rows : %o, cells : %o', rows, totalCells);

        // Handlebars only cares about the amount of elements and not the content
        var cellArray = new Array(totalCells).fill(0);
        // Let handlebars create our cells
        var cells = this.handleBarsTemplates.gridCell(cellArray);
        //console.log('_writeOutCellRows : %o - %o', this.$myContainer, this.$myContainer.find('.grid-container .bgGrid'));
        this.element.find('.grid-container .bgGrid').html(this.handleBarsTemplates.gridCell(cellArray));
        // Add a class that allows us to have a variable amount of rows
        this.element.find('figure.grid-container').addClass('grid--rows-' + rows);
    },


    // Methods
    _getPanelSet: function (id, initial) {
        var me = this;

        return new Promise(function (resolve, reject) {

            //console.log('Get Panel Set for node : ', id);

            var params = {
                pageIntInput: id,
                initial: initial,
                activeStickys: me.activeStickys
            };


            $.ajax({
                url: me.panelAPIUrl
                , data: params
                , method: 'POST'
            }).done(function (result) {
                console.log("Got panels : %o", result);

                me.panelJSON = result.Panels;

                // Is this a splash page. Splash pages on mobile need to be ordered differently from other page
                // Adding a class higher up allows this
                if (result.isSplashPage) {
                    $('.grid.grid--top').addClass('grid--splash');
                } else {
                    $('.grid.grid--top').removeClass('grid--splash');
                }
                me.subNavBottom = result.subnavToBottom;


                // Find out how many cells high we need the grid to be - lowestNeededCell
                if (initial) {
                    me._writeOutCellRows(result.lowestNeededCell);
                }

                //console.log('Setting base sticky value : ', result.baseSticky, result.clearSticky);
                me.activeStickys = result.activeStickys;
                me.removeStickys = result.removeStickys;
                resolve(result);
            }).fail(function (result) {
                reject(result);
            });

        });

    },

    _clearOutDomElements: function () {

        $all_grid_items = this.element.find('.grid--top .grid__item:not(' + this.sticky + ')');
        //console.log('Clearing elements : ', $all_grid_items);
        $all_grid_items.remove();

        //console.log('Remove stickys : ', this.removeStickys);

        if (this.removeStickys.length > 0) {
            // We need to remove some specific sticky elements
            var $allRemoves = null;
            $.each(this.removeStickys, function (index, val) {
                if ($allRemoves === null) {
                    $allRemoves = this.parent.element.find('.grid--top .grid__item' + this.parent.sticky + "[data-stickyid='" + val + "']");
                } else {
                    $allRemoves.add(this.parent.element.find('.grid--top .grid__item' + this.parent.sticky + "[data-stickyid='" + val + "']"));
                }

            }.bind({ parent: this }));

            //console.log('All removes : ', $allRemoves);
            $allRemoves.removeClass('grid__item--animating-in');
            $allRemoves.addClass('grid__item--animating-out');
            $allRemoves.addClass('grid__item--animating');

            setTimeout(function () {
                //console.log('Do remove : ', $allRemoves);
                // remove the actual element from the dom once the animation is complete
                $allRemoves.remove();
            }.bind({ parent: this }), this.animation_delay);

        }
    },

    _renderPanelsWithHandleBars: function () {

        var me = this;
        var newPanels = '';

        // Clear old panels out - May need to include a filter for "Sticky" here.
        //console.log('_clearOutDomElements');
        this._clearOutDomElements();


        // Only do this once
        if (this.firstRun) {
            this.handleBarsTemplates.image = Handlebars.compile(document.getElementById("ImagePanel").innerHTML);
            this.handleBarsTemplates.text = Handlebars.compile(document.getElementById("TextPanel").innerHTML);
            this.handleBarsTemplates.link = Handlebars.compile(document.getElementById("LinkPanel").innerHTML);
            this.handleBarsTemplates.subnav = Handlebars.compile(document.getElementById("SubnavPanel").innerHTML);
            this.handleBarsTemplates.team = Handlebars.compile(document.getElementById("TeamPanel").innerHTML);
            this.handleBarsTemplates.project = Handlebars.compile(document.getElementById("ProjectPanel").innerHTML);
            this.handleBarsTemplates.allTeam = Handlebars.compile(document.getElementById("AllTeam").innerHTML);
            this.handleBarsTemplates.mobileSpace = Handlebars.compile(document.getElementById("SpacerPanel").innerHTML);
            this.firstRun = false;
        }

        $.each(this.panelJSON, function (index, val) {

            switch (val.panelType) {
                case 'Text':
                    //console.log('Text template : ', val);
                    newPanels += me.handleBarsTemplates.text(val.panel);
                    break;
                case 'Image':
                    //console.log('Image template : ', val);
                    newPanels += me.handleBarsTemplates.image(val.panel);
                    break;
                case 'Link':
                    //console.log('Link template : ', val);
                    newPanels += me.handleBarsTemplates.link(val.panel);
                    break;
                case 'Subnav':
                    //console.log('Link template : ', val);
                    newPanels += me.handleBarsTemplates.subnav(val.panel);
                    break;
                case 'Team':
                    //console.log('Link template : ', val);
                    newPanels += me.handleBarsTemplates.team(val.panel);
                    break;
                case 'Project':
                    //console.log('Link template : ', val);
                    newPanels += me.handleBarsTemplates.project(val.panel);
                    break;
                case 'AllTeam':
                    //console.log('Link template : ', val);
                    newPanels += me.handleBarsTemplates.allTeam(val.panel);
                    break;
                case 'Spacer':
                    //console.log('Link template : ', val);
                    newPanels += me.handleBarsTemplates.mobileSpace(val.panel);
                    break;
                default:
                    console.log('No switch found for the panel type : ' + val.panelType);
            }
        });

        //console.log('panelHolderNode.append : ' , newPanels);
        this.panelHolderNode.append(newPanels);

        this.doMenuItemDivideLines();

        // Dom
        $('.lazy-load').Lazy();
        //$('.grid__item--link:eq(1), .grid__item--link:eq(3), .grid__item--link:eq(5)').addClass("grid__item--link--reverse");

        $('.grid__item--project').on('mouseenter touchstart touchmove', function(e){
            e.stopPropagation();
            $(this).addClass('grid__item--project--hover');
            // console.log("hey");
        });

        $('.grid__item--project').on('mouseleave touchend', function(e){
            e.stopPropagation();
            $(this).removeClass('grid__item--project--hover');
        });



    },

    _changePage: function (pageId) {

        $all_grid_items = this.element.find('.grid--top .grid__item:not(' + this.sticky + ')');

        grid_url = pageId;
        grid_animation_out_classes = $('.grid__item--animate-up-out, .grid__item--animate-right-out, .grid__item--animate-bottom-out, .grid__item--animate-left-out');

        // Remove and add wipe animation in + out classes
        $all_grid_items.removeClass('grid__item--animating-in');
        $all_grid_items.addClass('grid__item--animating-out');

        // Check to see if grid item has link
        if (grid_url) {

            // Add animation class
            $all_grid_items.addClass('grid__item--animating');

            // Check if item has an animation out class, otherwise apply animation down out
            if ($all_grid_items.is(grid_animation_out_classes)) {
                $all_grid_items.not(grid_animation_out_classes).addClass('grid__item--animate-down-out');
            }

            // Load new content after animation plays out
            setTimeout(function () {
                this.parent._getPanelSet(grid_url, false).then(function () {

                    this.parent._renderPanelsWithHandleBars();

                    // Add wipe animation after new content loaded
                    $all_grid_items.addClass('grid__item--animating-in');
                }.bind({ parent: this.parent }));

            }.bind({ parent: this }), this.animation_delay);
        }
    },

    breakGridAreaToArray: function (gridArea) {
        if (gridArea.indexOf('order') > -1) {
            // this style tag contains an order. Strip it
            // Always the first element?
            var orderEndTag = gridArea.indexOf(';');
            gridArea = gridArea.substring(orderEndTag + 1);
            //console.log('Only grid area : ', gridArea);
        }

        var ruleValues = gridArea.split(':');
        var ruleParts = ruleValues[1].split('/');
        return ruleParts;
    },

    doMenuItemDivideLines: function () {

        //console.log('doMenuItemDivideLines');

        var allMenus = this.panelHolderNode.find('.grid__item.grid__item--link.grid__item--sticky');

        // All the items that are sub menus - The all have the order: 10
        var validMenuItems = [];
        var allSubMenus = this.panelHolderNode.find('.grid__item.grid__item--link');
        $.each(allSubMenus, function (index, val) {
            var thisItem = $(val);

            //console.log('order : %o', thisItem.css('order'));
            if (thisItem.css('order') === '10') {
                validMenuItems.push(thisItem);
            }
        });

        //console.log('allSubMenus : %o', allSubMenus);


        var validMenuItemsY = [];
        $.each(allMenus, function (index, val) {

            var thisElement = $(val);
            //console.log('thisElement : %o ', thisElement);
            thisElement.removeClass('grid__item--link--reverse');

            var locationBits = this.parent.breakGridAreaToArray(thisElement.attr('style'));

            
            if (parseInt(locationBits[1]) === 9) {
                //console.log('Is in right column');
                //console.log('Adding one : ', parseInt(locationBits[0]));
                validMenuItemsY.push(parseInt(locationBits[0]));
                //validMenuItems.push($(val));
            } else {
                //console.log('Is in left column');
            }

        }.bind({ parent: this }));



       //console.log('validMenuItems : %o', validMenuItems);

        // Apply a class to every other menu for Dom
        for (var vm = 0; vm < validMenuItems.length; vm++) {
            //console.log('validMenuItems : %o', validMenuItems[vm]);

            if (vm % 2 !== 0) {
                //console.log('validMenuItems 2nd : %o', validMenuItems[vm]);
                validMenuItems[vm].addClass('grid__item--link--reverse');
            }
        }


        // Order our list of valid items
        validMenuItemsY.sort(function (a, b) { return a - b; });
        //console.log('Ordered array : ', validMenuItemsY);
        this.panelHolderNode.parent().find('.grid.bgGrid .grid__item.grid__item--no-border').removeClass('grid__item--no-border');

        // Now check if there is 2 consecutive numbers
        var last = 100; // Just so this won't match on the first number
        for (var i = 0; i < validMenuItemsY.length; i++) {
            //console.log('for : %o - %o', (last + 1), validMenuItemsY[i]);
            if (last + 1 === validMenuItemsY[i]) {

                var targetCell = validMenuItemsY[i] * 9 - 1;      // 0 based 

                this.panelHolderNode.parent().find('.grid.bgGrid .grid__item').eq(targetCell).addClass('grid__item--no-border');
            }
            last = validMenuItemsY[i];
        }



        // Subnav - Toggle between top and bottom
        // -3 is at the top 
        // 8 is at the bottom just above the main menu (10)
        // get the subnav element if it exists
        var subNav = this.panelHolderNode.find('.grid__item--subnav').last();
        //console.log('subNav : bottom: %o ', this.subNavBottom);
        if (subNav.length > 0) {
            // Got a subnav. 
            var subNavStyle = subNav.attr('style');      // Latest added subnav
            rulePartsReturn = this.breakGridAreaToArray(subNavStyle);
            var newArea = String.format('grid-area: {0} / {1} / {2} / {3}', facTrim(rulePartsReturn[0]), facTrim(rulePartsReturn[1]), facTrim(rulePartsReturn[2]), facTrim(rulePartsReturn[3]));

            if (this.subNavBottom) {
                newArea = 'order:8;' + newArea;
            } else {
                newArea = 'order:-3;' + newArea;
            }
            //console.log("sub nav : %o ", newArea);
            subNav.attr('style', newArea );
        } 

    },

    // Change the grid area rule to allow moving nav items from one side of the screen to the other
    changeGridAreaLocation: function ($element) {

        console.log('changeGridAreaLocation');

        // Reset all the subnav highlighted classes
        $('.grid__subnav-link').removeClass('grid__subnav-link--active');

        var oldGridLocation = $element.attr('style');
        var ruleParts = this.breakGridAreaToArray(oldGridLocation);
        //console.log('ruleParts : ', ruleParts);

        // grid-area: 1 / 9 / span 1 / span 1;
        // [0] - Top
        // [1] - Left
        // [0] - Height
        // [1] - Width

        var currentPosition = parseInt(ruleParts[1]);
        //console.log('currentPosition : ', currentPosition);

        var newPosition = 1;

        // Added a new active element. Move all other elements back
        // Get all nav items that are sticky
        var movingNavBack = false;
        var moveBackNavItem = null;
        var $stickyNavs = this.element.find('.grid__item.grid__item--link.grid__item--sticky');
        $stickyNavs.removeClass('grid__item--active');
        
        $.each($stickyNavs, function (index, val) {
            var $val = $(val);
            var rulePartsStickys = this.parent.breakGridAreaToArray($val.attr('style'));
            if (parseInt(rulePartsStickys[1]) === 1) {
                moveBackNavItem = $val;
                movingNavBack = true;
            }
        }.bind({ parent: this }));


        if (movingNavBack) {
            // This moves the old nav item back to the right
            var rulePartsReturn = this.breakGridAreaToArray(moveBackNavItem.attr('style'));
            moveBackNavItem.removeClass('grid__item--animating-in').addClass('grid__item--animating-out').addClass('grid__item--animating');
            setTimeout(function () {
                moveBackNavItem.removeClass('grid__item--animating').removeClass('grid__item--animating-out').addClass('grid__item--animating-in');
                var newArea = String.format('grid-area: {0} / {1} / {2} / {3}', facTrim(rulePartsReturn[0]), 9, facTrim(rulePartsReturn[2]), facTrim(rulePartsReturn[3]));

                // We also need to order this for mobile screens 
                // Nav items that are not active need to have an order of 2
                newArea = 'order:10;' + newArea;

                moveBackNavItem.attr('style', newArea);

                moveBackNavItem.removeClass('grid__item--active');
                
            }, this.animation_delay);

        }

        $element.removeClass('grid__item--animating-in').addClass('grid__item--animating-out').addClass('grid__item--animating');
        setTimeout(function () {
            $element.removeClass('grid__item--animating');
            var newArea = String.format('grid-area: {0} / {1} / {2} / {3}', facTrim(ruleParts[0]), newPosition, facTrim(ruleParts[2]), facTrim(ruleParts[3]));

            // We also need to order this for mobile screens 
            // Nav items that are not active need to have an order of -4
            newArea = 'order:-4;' + newArea;

            $element.attr('style', newArea);
            $element.addClass('grid__item--active');

        }.bind({ parent: this }), this.animation_delay);

        // Add divide lines between menu items
        this.doMenuItemDivideLines();

    },

    setUpEvents: function () {

        // Click on any panel with a link that's not a subnav
        this.panelHolderNode.on('click', '.grid__item:not(.grid__item--subnav)', function (event) {

            // Stop this from firing on a team SVG click
            if ($(event.target).attr('class').indexOf('team-member') === -1) {

                var $self = $(event.target).closest('.grid__item');

                // Are we viewing a sticky navigation item - Replace the .
                if ($self.hasClass(this.parent.sticky.replace('.', '')) && $self.hasClass('grid__item--link') && !$self.hasClass('image--link')) {
                    // Move this item to the left and move any other active items back to the right
                    this.parent.changeGridAreaLocation($self);
                }

                if ($self.hasClass(this.parent.sticky.replace('.', '')) && $self.hasClass('grid__item--image')) {
                    // Move this item to the left and move any other active items back to the right
                    console.log('Grid item image sticky clicked');
                    $('.grid__item.grid__item--image.grid__item--sticky.active').removeClass('active');
                    //this.parent.changeGridAreaLocation($self);
                    $self.addClass('active');
                }

                //console.log('Mobile click :', isMobile);
                scrollToAnchor('#FacGrid_' + this.parent.thisPanel);

                grid_url = $($self).data('url');
                this.parent._changePage(grid_url);
            } else {
                console.log('Skipped as it\'s team');
            }

        }.bind({ parent: this }));


        // A click on a subnav item
        this.panelHolderNode.on('click', 'ul.grid__subnav li.grid__subnav-item a', function (event) {

            event.preventDefault();

            // Stop this from firing on a team SVG click
            if ($(event.target).attr('class').indexOf('team-member') === -1) {

                var target = $(event.target).attr('data-location');

                var $container = $(event.target).closest('.grid__item');

                $container.find('.grid__subnav-link--active').removeClass('grid__subnav-link--active');
                $(event.target).addClass('grid__subnav-link--active');


                console.log('Change page');
                this.parent._changePage(target);
            }
            else
            {
                console.log('Skipped as it\'s team');
            }

        }.bind({ parent: this }));


        // console.log('Panel holder node : ', this.panelHolderNode);
        // Team icons
        if ("ontouchstart" in document.documentElement)
        {
            this.panelHolderNode.on('click', '.grid__team-member', function (event) {
                $('.grid__team-image').attr('src', '');
                var activeClass = 'grid__team-member--active';
                var target = $(event.target);
                console.log('Team icons : %o' , target);

                event.preventDefault();

                var teamName = target.attr('data-name');
                var teamJob = target.attr('data-jobtitle');
                var teamText = target.attr('data-text');
                var teamImg = target.attr('data-image') + "&width=142&height=162&anchor=top";
                var teamImgAlt =  target.attr('data-imagealt');

                $('.grid__team-title').html(teamName);
                $('.grid__team-sub').html(teamJob);
                $('.grid__team-text').html(teamText);

                if (teamImg !== "") {
                    $('.grid__team-image').css('display','block').attr('src', teamImg).attr('alt', teamImgAlt);
                } else {
                    $('.grid__team-image').css('display', 'none');
                }

                // Scroll for click but not for roll overs
                if (event.type === 'click') {
                    scrollToAnchor('.grid-panel');
                }


                $('.'+activeClass).removeClass(activeClass);
                target.addClass(activeClass);


            }.bind({ parent: this }));
        }
        else {
            this.panelHolderNode.on('click mouseover', '.grid__team-member', function (event) {
                $('.grid__team-image').attr('src', '');
                var activeClass = 'grid__team-member--active';
                var target = $(event.target);
                console.log('Team icons : %o' , target);

                event.preventDefault();

                var teamName = target.attr('data-name');
                var teamJob = target.attr('data-jobtitle');
                var teamText = target.attr('data-text');
                var teamImg = target.attr('data-image') + "&width=142&height=162&anchor=top";
                var teamImgAlt =  target.attr('data-imagealt');

                $('.grid__team-title').html(teamName);
                $('.grid__team-sub').html(teamJob);
                $('.grid__team-text').html(teamText);

                if (teamImg !== "") {
                    $('.grid__team-image').css('display','block').attr('src', teamImg).attr('alt', teamImgAlt);
                } else {
                    $('.grid__team-image').css('display', 'none');
                }

                // Scroll for click but not for roll overs
                if (event.type === 'click') {
                    scrollToAnchor('.grid-panel');
                }


                $('.'+activeClass).removeClass(activeClass);
                target.addClass(activeClass);


            }.bind({ parent: this }));
        }

    },




    // Widget init
    options: {
        initialID: 0
    },
    _create: function () {


        var me = this;
        this.thisPanel = this.options.initialID;
        this.panelHolderNode = this.element.find('.grid--top');
        //this.$myContainer = $('#FacGrid_' + this.options.initialID);

        this.setUpEvents();

        //console.log('Init JQuery CC Grid widget : ', this.element);


        this._getPanelSet(this.options.initialID, true).then(function () {
            me._renderPanelsWithHandleBars();
            //me.doInitialMenuPosition();
            

            // Add wipe animation after new content loaded
            $('.grid--top .grid__item').addClass('grid__item--animating-in');

        });

    }

});